import { Circle } from '@phosphor-icons/react';
import { Inline, Text } from '@etg/wings';
import { TripType } from '@eti/schema-types';
import { useTranslation } from '@eti/providers';
import { useMemo } from 'react';
import { useAuth } from '@eti/authentication';
import { useOrderDetails } from '../../containers/OrderDetailsContext';
import Dates from './Dates';

interface BasicTripInfoProps {
  shouldShowOriginalDates: boolean;
}
const BasicTripInfo = ({ shouldShowOriginalDates }: BasicTripInfoProps) => {
  const { t } = useTranslation();
  const { journeyType, travelers } = useOrderDetails();
  const { user } = useAuth();

  const journeyTypeText = useMemo(() => {
    switch (journeyType) {
      case TripType.OneWay:
        return t('OrderDetails.JourneyType.OneWay');
      case TripType.Return:
        return t('OrderDetails.JourneyType.Return');
      default:
        return t('OrderDetails.JourneyType.MultiStop');
    }
  }, [journeyType, t]);

  const passengerText =
    travelers.length > 1
      ? t('OrderDetails.PassengerCount.Plural', travelers.length)
      : t('OrderDetails.PassengerCount.Singular', travelers.length);

  return (
    <Inline alignY="center" data-testid="basic-trip-info" spacing={8}>
      <Dates shouldShowOriginal={shouldShowOriginalDates} />
      <Circle aria-hidden="true" color="#737373" size={6} weight="fill" />
      <Text aria-hidden="true" data-testid={`order-${user?.sessionOrderNumber}-journey-type`}>
        {journeyTypeText}
      </Text>
      <Circle aria-hidden="true" color="#737373" size={6} weight="fill" />
      <Text data-testid={`order-${user?.sessionOrderNumber}-passengers`}>{passengerText}</Text>
    </Inline>
  );
};
export default BasicTripInfo;
